import { render } from "./index.vue?vue&type=template&id=56a1f030"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=56a1f030&lang=css"

import exportComponent from "/Users/n0m4dz/workspace/projects/seeroo-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__